export default function MockDataBanner({
  visible,
  message = 'The live data API is currently unavailable. Values shown are placeholder data and should not be used for financial decisions.',
}: {
  visible: boolean
  /** Override for modules where the default financial wording does not apply */
  message?: string
}) {
  if (!visible) return null

  return (
    <div className="bg-amber-500/10 border border-amber-500/30 rounded-xl px-4 py-3 mb-6 flex items-start gap-3">
      <svg className="w-5 h-5 text-amber-600 dark:text-amber-400 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
      </svg>
      <div>
        <p className="text-amber-600 dark:text-amber-400 text-sm font-medium">Sample Data — Not Real-Time</p>
        <p className="text-amber-600/70 dark:text-amber-400/70 text-xs mt-0.5">{message}</p>
      </div>
    </div>
  )
}
